module.exports = __webpack_public_path__ + "img/clients.461a7a32.svg";